import { get} from "./api";
import URLS from "../constants/api";


export const getDashboardData = async (type:string
) => {
  const response = await get(URLS.TOTALDOCS(type));
  return response;
};
